import { IconManagerProps } from '@speeki/icons';

import {
    ActionIcon,
    ActionName,
    ActionNameWrapper,
    OptionIcon,
    OptionName,
    OptionNameWrapper,
    OptionWrapper,
} from '@domains/settings/atoms/Option/Option.styled';

interface OptionProps {
    actionName?: string;
    icon: IconManagerProps['icon'];
    onPress?: () => void;
    optionName?: string;
}

export const Option = ({
    actionName,
    icon,
    onPress,
    optionName,
}: OptionProps) => (
    <OptionWrapper onClick={onPress}>
        <OptionNameWrapper>
            <OptionIcon icon={icon} size={16} />
            <OptionName>{optionName ?? ''}</OptionName>
        </OptionNameWrapper>
        <ActionNameWrapper>
            <ActionName>{actionName ?? ''}</ActionName>
        </ActionNameWrapper>
        <ActionIcon icon={'SvgChevronRight'} size={10} />
    </OptionWrapper>
);
